import { authAxios, getAuthInfo } from './axiosInstance';

export const chatService = {
    // Récupérer le nombre de messages non lus pour toutes les conversations
    async getUnreadMessagesCount() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/chat/garage/${garageId}/unread-count`);
            return response.data.totalUnreadCount || 0;
        } catch (error) {
            console.error('Erreur lors de la récupération du nombre de messages non lus:', error);
            return 0;
        }
    },

    // Récupérer les messages d'une conversation entre un client et un garage pour une inspection
    async getConversationMessages(inspectionId: string, clientId: string) {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/chat/conversations/${inspectionId}/${garageId}/${clientId}/messages`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des messages:', error);
            throw error;
        }
    },

    // Envoyer un message
    async sendMessage(message: {
        inspectionId: string,
        clientId: string,
        content: string,
        type?: string
    }) {
        try {
            const { garageId } = getAuthInfo();
            const sender = {
                id: garageId,
                type: 'GARAGE',
                name: JSON.parse(localStorage.getItem('user') || '{}').name || 'Garagiste'
            };

            // Générer le conversationId sur le client pour éviter une requête supplémentaire
            const conversationId = `${message.inspectionId}-${garageId}-${message.clientId}`;

            const response = await authAxios.post(`/chat/messages`, {
                inspectionId: message.inspectionId,
                conversationId,
                content: message.content,
                garageId,
                clientId: message.clientId,
                sender,
                type: message.type || 'TEXT',
                timestamp: new Date()
            });

            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du message:', error);
            throw error;
        }
    },

    // Marquer tous les messages d'une conversation comme lus
    async markMessagesAsRead(inspectionId: string, clientId: string) {
        try {
            const { garageId } = getAuthInfo();
            // Générer le conversationId
            const conversationId = `${inspectionId}-${garageId}-${clientId}`;

            const response = await authAxios.put(`/chat/messages/${conversationId}/read`, {
                userId: garageId
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du marquage des messages comme lus:', error);
            throw error;
        }
    },

    // Récupérer toutes les discussions du garage
    async getAllDiscussionsByGarageId() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/chat/garage/${garageId}/discussions`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des discussions:', error);
            throw error;
        }
    },

    // Envoyer un statut de frappe
    async sendTypingStatus(conversationId: string, isTyping: boolean) {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.post(`/chat/conversations/${conversationId}/typing`, {
                userId: garageId,
                isTyping
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du statut de frappe:', error);
            throw error;
        }
    },

    // Récupérer le nombre de messages non lus pour une conversation spécifique
    async getUnreadCount(inspectionId: string, clientId: string) {
        try {
            const { garageId } = getAuthInfo();
            // Générer le conversationId
            const conversationId = `${inspectionId}-${garageId}-${clientId}`;

            const response = await authAxios.get(`/chat/messages/unread/${conversationId}?userId=${garageId}`);
            return response.data.count || 0;
        } catch (error) {
            console.error('Erreur lors de la récupération du nombre de messages non lus:', error);
            return 0;
        }
    }
};